import { render, staticRenderFns } from "./DepositPage.vue?vue&type=template&id=6fc15d38"
import script from "./DepositPage.vue?vue&type=script&lang=js"
export * from "./DepositPage.vue?vue&type=script&lang=js"
import style0 from "./DepositPage.vue?vue&type=style&index=0&id=6fc15d38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports